// frontend/src/i18n/LanguageContext.js

import React, { createContext, useState, useContext, useEffect } from 'react'

/**
 * Contexto React para gestionar el idioma global de la aplicación.
 */
const LanguageContext = createContext()

/**
 * Proveedor del contexto de idioma que envuelve la aplicación.
 * Maneja el estado del idioma seleccionado y persiste en localStorage.
 */
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('lang') || 'en'
  })

  // Cada vez que cambia el idioma, se guarda en localStorage.
  useEffect(() => {
    localStorage.setItem('lang', language)
  }, [language])

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

/**
 * Hook para consumir el contexto de idioma en componentes React.
 * @returns {{ language: string, setLanguage: function }}
 */
export const useLanguage = () => useContext(LanguageContext)
